import * as React from 'react';

import PlatformPage from '../../components/layout/Content/PlatformPage';

const WebComponents: React.FunctionComponent = () => {
  const title = 'Unifi Web';
  const slug = '/web/components/';
  const intro = 'View demos and learn about using available Unifi components for Web.';

  return <PlatformPage {...{ title, slug, intro, platform: 'web' }} />;
};

export default WebComponents;
